<template>
  <div class="test_page">
    <steppers-test-loader></steppers-test-loader>
    <v-stepper alt-labels v-model="step">
      <v-stepper-header class="steppers_container">
        <v-stepper-step step="1" :key="`1-step`" :complete="step > 1"
          >Examen</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step
          step="2"
          :key="`2-step`"
          :complete="step > 2"
          v-if="this.program && !this.program.recognition"
          >Asesoría</v-stepper-step
        >
        <v-stepper-step step="2" :key="`2-step`" :complete="step > 2" v-else
          >Evaluando resultados</v-stepper-step
        >
        <v-divider v-if="this.program && !this.program.recognition"></v-divider>
        <v-stepper-step
          step="3"
          :key="`3-step`"
          v-if="this.program && !this.program.recognition"
          >Matrícula</v-stepper-step
        >
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content :key="`1-content`" step="1">
          <test-complete
            v-if="test"
            @nextStep="nextStep($event)"
            @updateValueRecognition="updateValueRecognition"
          />
          <test-form v-else @completed="testCompleted" />
        </v-stepper-content>
        <v-stepper-content
          :key="`2-content`"
          step="2"
          v-if="this.program && !this.program.recognition"
        >
          <test-schedule
            v-if="schedule == 'date'"
            @completed="dateCompleted"
            @goTo="goTo($event)"
          />
          <test-call
            v-else-if="schedule == 'call'"
            @completed="callCompleted"
          />
          <test-call-progress
            v-else-if="schedule == 'progress'"
            @completed="progressCompleted"
          />
        </v-stepper-content>
        <v-stepper-content :key="`2-content`" step="2" v-else>
          <test-recognition v-if="this.recognitionObtained"></test-recognition>
        </v-stepper-content>
        <v-stepper-content
          :key="`3-content`"
          step="3"
          v-if="!this.program.recognition"
        >
          <test-result v-if="schedule == 'result'" />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="completed" width="760" persistent>
      <v-card class="rate">
        <div class="rate_title">
          ¿Califica la asesoría?
        </div>
        <div class="rate_stars">
          <div class="star" v-for="n in 5" :key="`star_` + n">
            <img
              v-if="n > star"
              src="@/assets/images/evaluation/star_off.svg"
              @click="starSelected(n)"
            />
            <img
              v-else
              src="@/assets/images/evaluation/star_on.svg"
              @click="starSelected(n)"
            />
          </div>
        </div>
        <div class="rate_description">
          <span>Muy mala</span>
          <span>Muy buena</span>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SteppersTestLoader from "@/containers/loaders/SteppersTestLoader";
import TestForm from "@/containers/test/TestForm";
import TestComplete from "@/containers/test/TestComplete";
import TestSchedule from "@/containers/test/TestSchedule";
import TestCall from "@/containers/test/TestCall";
import TestCallProgress from "@/containers/test/TestCallProgress";
import TestResult from "@/containers/test/TestResult";
import TestRecognition from "@/containers/test/TestRecognition";

import axios from "@/axios-auth";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  components: {
    "steppers-test-loader": SteppersTestLoader,
    "test-form": TestForm,
    "test-complete": TestComplete,
    "test-schedule": TestSchedule,
    "test-call": TestCall,
    "test-call-progress": TestCallProgress,
    "test-result": TestResult,
    "test-recognition": TestRecognition
  },
  data() {
    return {
      user: null,
      step: 1,
      stepQuery: "",
      statusQuery: "",
      test: false,
      schedule: "date",
      completed: false,
      star: 0,
      advisory: null,
      recognitionObtained: false
    };
  },
  methods: {
    ...mapActions(["verifyPostulation"]),
    ...mapMutations(["setScoreResult"]),
    updateValueRecognition(obtained) {
      this.recognitionObtained = obtained;
      console.log("this.recognitionObtained", this.recognitionObtained);
    },
    goTo(schedule) {
      this.schedule = schedule;
    },
    registerGrade() {
      //TODO
      let obj = {
        application_id: this.postulation.id,
        grade: this.star.toString()
      };
      axios
        .post(`users/register-grade/`, obj, {
          headers: { Authorization: "Token " + this.user.token }
        })
        .then(response => {
          this.advisory = response.data;

          setTimeout(() => {
            this.completed = false;
            this.schedule = "result";

            this.$vuetify.goTo("#top", {
              duration: 0,
              offset: 0,
              easing: "linear"
            });
          }, 2000);
        })
        .catch(err => {
          console.error(err);
        });
    },
    testCompleted() {
      this.$vuetify.goTo("#top", {
        duration: 0,
        offset: 0,
        easing: "linear"
      });
      this.test = true;
    },
    dateCompleted() {
      this.$vuetify.goTo("#top", {
        duration: 0,
        offset: 0,
        easing: "linear"
      });
      this.schedule = "call";
    },
    callCompleted() {
      this.$vuetify.goTo("#top", {
        duration: 0,
        offset: 0,
        easing: "linear"
      });
      this.schedule = "progress";
    },
    progressCompleted() {
      this.completed = true;
      this.step = 3;
    },
    nextStep(n) {
      this.step = n;
    },
    starSelected(n) {
      if (this.star == 0) {
        this.star = n;

        this.registerGrade();
      }
    }
  },
  computed: {
    ...mapGetters({
      language: "language",
      program: "program",
      postulation: "postulation",
      postulationIsNull: "postulationIsNull"
    })
  },
  mounted() {
    this.verifyPostulation();

    if (this.postulationIsNull) {
      this.$router.push({ path: `/principal` });
    }

    this.user = this.$store.state.usuario;

    this.stepQuery = this.$route.params["step"];
    this.statusQuery = this.$route.params["status"];
    if (this.stepQuery == "schedule") {
      this.nextStep(2);
    }

    if (this.statusQuery == "completed") {
      this.nextStep(2);
      this.schedule = "progress";
      this.completed = true;
    }

    if (this.statusQuery == "rate") {
      this.completed = true;
      this.step = 3;
    }
  }
};
</script>
